import { render, staticRenderFns } from "./JVM.vue?vue&type=template&id=01b6ce62&scoped=true"
import script from "./JVM.vue?vue&type=script&lang=js"
export * from "./JVM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b6ce62",
  null
  
)

export default component.exports